import axios, { AxiosResponse } from 'axios';

export interface IClaimApi {
  claimTransmit(step: any): Promise<AxiosResponse<any>>;
  claimSherpaSimTransmit(step: any): Promise<AxiosResponse<any>>;
  uploadSherpaDocument(step: any): Promise<AxiosResponse<any>>;
  workflowSherpaSimTransmit(step: any): Promise<AxiosResponse<any>>;
  detectRefusal(step: any): Promise<AxiosResponse<any>>;
  getClaim(claimNumber: any): Promise<AxiosResponse<any>>;
  updateClaimDetails(claimDetailsDto: any): Promise<AxiosResponse<any>>;
}

class ClaimApi implements IClaimApi {
  async claimTransmit(params: any): Promise<AxiosResponse<any>> {
    return await axios.put('/api/claim-transmit', params);
  }

  async claimSherpaSimTransmit(params: any): Promise<AxiosResponse<any>> {
    return await axios.put('/api/sherpa-claim-transmit', params);
  }
  async uploadSherpaDocument(params: any): Promise<AxiosResponse<any>> {
    return await axios.put('/api/upload-sherpa-document', params);
  }

  async workflowSherpaSimTransmit(params: any): Promise<AxiosResponse<any>> {
    return await axios.put(`/api/sherpa-create-workflow`, params);
  }

  async detectRefusal(params: any): Promise<AxiosResponse<any>> {
    return await axios.post('/api/detect-refusal', params);
  }

  async getClaim(claimNumber): Promise<AxiosResponse<any>> {
    return await axios.get(`/api/claim/${claimNumber}`);
  }

  async updateClaimDetails(claimDetailsDto: any): Promise<AxiosResponse<any>> {
    return await axios.post('/api/updateClaimDetails', claimDetailsDto);
  }
}

const claimApi = new ClaimApi();

export { claimApi };
